/**
 * Bind the JH IDP OIDC `state` (and IdP origin) to this browser tab so the
 * /callback handler can reject forged authorization codes (CWE-352).
 */

export const OIDC_STATE_STORAGE_KEY = "oidcLoginState";
export const OIDC_IDP_ORIGIN_STORAGE_KEY = "oidcIdpOrigin";

export function clearOidcLoginState(): void {
  sessionStorage.removeItem(OIDC_STATE_STORAGE_KEY);
  sessionStorage.removeItem(OIDC_IDP_ORIGIN_STORAGE_KEY);
}

/** Parse `state` + origin from GET_AUTHURL's authURL and store them. False if missing/invalid. */
export function storeOidcLoginStateFromAuthUrl(authURL: string): boolean {
  try {
    const url = new URL(authURL);
    const state = url.searchParams.get("state");
    if (!state) {
      return false;
    }
    sessionStorage.setItem(OIDC_STATE_STORAGE_KEY, state);
    sessionStorage.setItem(OIDC_IDP_ORIGIN_STORAGE_KEY, url.origin);
    return true;
  } catch {
    return false;
  }
}

/**
 * One-time check: callback `state` must match the value stored at SSO click,
 * and `iss` must share the IdP origin. Always clears stored values (no replay).
 */
export function consumeAndValidateOidcCallback(params: {
  state: string | null;
  iss: string | null;
}): boolean {
  const expectedState = sessionStorage.getItem(OIDC_STATE_STORAGE_KEY);
  const expectedOrigin = sessionStorage.getItem(OIDC_IDP_ORIGIN_STORAGE_KEY);
  clearOidcLoginState();

  if (!params.state || !expectedState || params.state !== expectedState) {
    return false;
  }
  if (!params.iss || !expectedOrigin) {
    return false;
  }
  try {
    return new URL(params.iss).origin === expectedOrigin;
  } catch {
    return false;
  }
}
